export default __webpack_public_path__ + "static/media/IMG_0686.351a4fef.jpg";